import { startCase } from 'lodash';

import { AssetClass } from '@/cip/_openapi/portfolio-optimizer';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/utils/cn';

const assetClassColorMap: Record<AssetClass, string> = {
    Bond: 'bg-blue-100 text-blue-800 hover:bg-blue-200 border-blue-200',
    Equity: 'bg-orange-100 text-orange-800 hover:bg-orange-200 border-orange-200',
    Options: 'bg-red-100 text-red-800 hover:bg-red-200 border-red-200',
    Futures: 'bg-purple-100 text-purple-800 hover:bg-purple-200 border-purple-200',
    Other: 'bg-gray-100 text-gray-800 hover:bg-gray-200 border-border',
};

export const AssetClassBadge = ({ assetClass }: { assetClass: AssetClass }) => {
    const colorClasses = assetClassColorMap[assetClass] || assetClassColorMap.Other;

    return <Badge className={cn('border-transparent', colorClasses)}>{startCase(assetClass)}</Badge>;
};
